import wootConstants from 'dashboard/constants/globals';
import { isVoiceCallEnabled, INBOX_TYPES } from './inbox';

const { AVAILABILITY_STATUS_KEYS, AVAILABILITY_STATUS_META } = wootConstants;

// Channels that exist for nothing but calls. isVoiceCallEnabled can't be the
// only test here: it also demands a `voice_enabled` flag, which the inbox
// payload emits for Twilio, WhatsApp and MANGO but not for UIS — so a UIS-only
// account would be told it has no telephony and lose the call statuses.
// Messaging channels that merely *can* carry voice still go through that flag.
const VOICE_ONLY_CHANNELS = [
  INBOX_TYPES.UIS,
  INBOX_TYPES.MANGO,
  INBOX_TYPES.MEGAPBX,
];

const LABEL_KEY = {
  online: 'ONLINE',
  calls_only: 'CALLS_ONLY',
  chats_only: 'CHATS_ONLY',
  busy: 'BUSY',
  offline: 'OFFLINE',
};

export const hasTelephony = inboxes =>
  (inboxes || []).some(
    inbox =>
      VOICE_ONLY_CHANNELS.includes(inbox?.channel_type || inbox?.channelType) ||
      isVoiceCallEnabled(inbox)
  );

/**
 * The status picker used to be positional — three labels zipped against three
 * keys by index. With five statuses, and with the call-flavoured ones hidden on
 * accounts that have no voice inbox, the list length varies, so every consumer
 * builds it from keys instead.
 */
export const availabilityStatusOptions = (t, { telephony = false } = {}) =>
  AVAILABILITY_STATUS_KEYS.filter(
    key => telephony || !AVAILABILITY_STATUS_META[key].requiresTelephony
  ).map(key => {
    // Plain "Online" has to spell out that it covers calls too, but only where
    // there are phones — on a helpdesk without telephony it would be nonsense.
    const labelKey =
      key === 'online' && telephony ? 'ONLINE_WITH_CALLS' : LABEL_KEY[key];
    return {
      value: key,
      label: t(`PROFILE_SETTINGS.FORM.AVAILABILITY.STATUS.${labelKey}`),
      color: AVAILABILITY_STATUS_META[key].color,
    };
  });
